import styled from 'styled-components';

interface ContainerProps {
    $focused?: boolean;
}

export const Container = styled.div<ContainerProps>`
    padding: 5px;
    border-radius: 10px;
    outline: none;
    border: 2px solid ${(props) => (props.$focused ? '#fff' : 'transparent')};
    transition: border-color 0.2s ease;
`;

export const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: -8px;
    flex: 1;
    align-items: top;
`;

interface ICol {
    size: number;
}

export const Col = styled.div<ICol>`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px;
    flex: 0 0 ${(props) => (props.size / 12) * 100}%;
    max-width: ${(props) => (props.size / 12) * 100}%;
    @media (max-width: 768px) {
        flex: 0 0 100%;
        max-width: 100%;
    }
    height: 33px;
`;

export const DateTimeText = styled.div`
    font-size: 0.9rem;
`;
